/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

// 同意管理 (CMP) タグは他モジュールより先に読み込みを開始する (本番のみ。lib/cmp.ts)。
// CMP は接続許可リスト (CSP) を適用するため、計測タグより先に読み込む必要がある。
import "@/lib/cmp";
// GA の初期化 (本番のみ。lib/analytics/init.ts)。初回イベントにも伏字処理済みの URL を載せるため
// React の描画より前に実行する。
import "@/lib/analytics/init";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";

// biome-ignore lint/style/noNonNullAssertion: root 要素は index.html に静的に存在する
const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
